import { render, staticRenderFns } from "./UserStamp.vue?vue&type=template&id=4e833aa6&scoped=true&"
import script from "./UserStamp.ts?vue&type=script&lang=ts&"
export * from "./UserStamp.ts?vue&type=script&lang=ts&"
import style0 from "./UserStamp.css?vue&type=style&index=0&id=4e833aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e833aa6",
  null
  
)

export default component.exports